import type { SupTransactionType, SupWeb3DepositStep } from "@/types";
import React, { type Dispatch, type SetStateAction } from "react";

import Web3CommonCartSwitch from "@/components/Web3/Common/Cart/Switch";
import { SupArrowBack } from "@repo/core-ui";

interface Web3CommonHeaderProps {
  step?: SupWeb3DepositStep;
  setStep?: Dispatch<SetStateAction<SupWeb3DepositStep>>;
  type?: SupTransactionType;
}

export default function Web3CommonHeader({ step = "Default", setStep, type = "deposit" }: Web3CommonHeaderProps) {
  const headerText = step === "Balance" ? (type === "deposit" ? "FUNDING TOKEN" : "WITHDRAW TO TOKEN") : step === "Finished" ? "Transaction Initiated" : type;

  return (
    <header className="relative flex h-[60px] items-center justify-between py-[10px]">
      {step === "Balance" && (
        <button className="btn-icon mr-2" onClick={() => setStep?.("Calculate")}>
          <SupArrowBack className="h-5 w-5" />
        </button>
      )}
      <h2 className="txt-header-dgt my-0 mr-auto uppercase">{headerText}</h2>
      {!["Finished", "Balance"].includes(step) && <Web3CommonCartSwitch />}
    </header>
  );
}
